import React from 'react';


const Servizi = ({ data }) => {
    const { content1, content2, img} = data;

  return (
    <section className="st-about-wrap" id='about'>
      <div className="st-height-b120 st-height-lg-b50" />
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <div className="st-vertical-middle">
              <div className="st-vertical-middle-in">
                <div className="st-text-block st-style1">
                  <div className="st-height-b20 st-height-lg-b20" />
                  <div className="st-text-block-text">
                    <div dangerouslySetInnerHTML={{ __html: content1 }} />
                  </div>
                  <div className="st-height-b25 st-height-lg-b25" />
                </div>
              </div>
            </div>
            <div className="st-height-b0 st-height-lg-b30" />
          </div>
          {/* .col */}
          <div className="col-lg-5 wow fadeInRight" data-wow-duration="0.8s" data-wow-delay="0.2s" >
            <img src={img} alt="service" />
          </div>
        </div>
              <div className="row">
                  <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                          <div className="st-text-block st-style1">
                              <div className="st-height-b20 st-height-lg-b20" />
                              <div className="st-text-block-text">
                                  <div dangerouslySetInnerHTML={{ __html: content2 }} />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        </div>
    </section>
  )
}

export default Servizi
